import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import { connect } from 'react-redux';
import { lookUpIdValueSelector } from 'selectors/generic';
import theme from 'source/theme';
import arrayToObject from 'utils/arrayToObject';

const columns = units => [
  { title: 'Tipo', field: 'type' },
  { title: 'Subtipo', field: 'subtype' },
  { title: 'Nome', field: 'name' },
  { title: 'Valor', field: 'value' },
  {
    title: 'Unidade',
    field: 'unit_id',
    render: id => units[id]
  }
];

const Component = props => {
  const {
    conditions, scenarioDescriptor, scenarioDescriptorConditions,
    title, units
  } = props;

  const filteredSDC = scenarioDescriptorConditions.filter(sdc =>
    sdc.scenario_descriptor_id === scenarioDescriptor.id
  );

  const fsdcByConditionId = arrayToObject(filteredSDC, 'condition_id');

  const filteredConditions = conditions
    .filter(c => filteredSDC.map(sdc => sdc.condition_id).includes(c.id))
    .map(c =>  ({
      ...c,
      unit_id: fsdcByConditionId[c.id].unit_id,
      value: fsdcByConditionId[c.id].value
    }));

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns(units)} rows={filteredConditions} title={title}/>
    </div>
  );
};

const makemapStateToProps = () => {
  const units = lookUpIdValueSelector('units', ['name']);
  const mapStateToProps = (state, props) => ({
    conditions: state.conditions.data,
    scenarioDescriptorConditions: state.scenarioDescriptorConditions.data,
    units: units(state)
  });
  return mapStateToProps;
};

export default connect(makemapStateToProps)(Component);
